import * as React from 'react'
import { Modal, Form, Tooltip, Button } from 'antd'
import { isEmpty, pick } from 'lodash'
import copyToClipboard from 'copy-to-clipboard'
import { t } from 'helpers/i18n'
import { stopEvent } from 'helpers/events'
import { showValidationError } from 'helpers/errors'
import Select from 'elements/Select'
import Icon from 'elements/Icon'

function FormView(props) {
  const selectRecipientsRef = React.useRef(null)

  const [recipients, setRecipients] = React.useState([])

  function handleSubmit(e) {
    stopEvent(e)

    props.form.validateFields((errors, values) => {
      if (isEmpty(errors)) {
        props.onSubmit?.(recipients)
      } else {
        showValidationError()
      }
    })
  }

  React.useEffect(() => {
    setRecipients([])

    props.form.resetFields(['recipients'])

    if (props.visible) {
      window.setTimeout(() => selectRecipientsRef.current?.focus?.(), 1000)
    }
  }, [props.visible])

  return (
    <Modal
      title={t('sendEmail')}
      visible={props.visible}
      okText={t('send')}
      onOk={handleSubmit}
      okButtonProps={pick(props, ['loading'])}
      onCancel={props.onCancel}
    >
      <Form layout="vertical" onSubmit={handleSubmit} colon={false}>
        <Form.Item label={t('recipients')}>
          <div className="tofino-label-buttons">
            <Tooltip title={t('copyToClipboard')}>
              <Button
                size="small"
                onClick={() => {
                  copyToClipboard(recipients.join(' '), {
                    message: t('copyToClipboard'),
                    format: 'text/plain',
                  })
                }}
              >
                <Icon type="FileCopy" />
              </Button>
            </Tooltip>
          </div>
          {props.form.getFieldDecorator('recipients', {
            rules: [{ required: true, message: t('requiredField') }],
          })(
            <Select
              ref={selectRecipientsRef}
              mode="tags"
              tokenSeparators={[',', ' ', ';']}
              maxTagCount={100}
              onChange={(values) => setRecipients(values)}
              autoFocus
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Form.create()(FormView)
